<p-card class="p-3" header="Configuración">
  <div class="flex flex-column gap-2 md:flex-row md:align-items-center md:justify-content-between">
    <div>
      Define cuándo se considera horario normal y cuándo aplica el horario de guardia.
      Los días marcados como festivos aplican siempre el horario de guardia.
    </div>
    <div class="text-600" *ngIf="!allowWrite">
      Visualización en solo lectura. Se requiere el permiso VOIP.SCHEDULE_ACCESS para modificar los horarios.
    </div>
  </div>
</p-card>

<p-card class="p-3 mt-3" header="Horario normal">
  <div class="text-600">Estas franjas se utilizarán cuando el día no sea festivo y no entre en horario de guardia.</div>

  <div class="rule-row rule-fields mt-3" *ngFor="let rule of normalRules; let index = index">
    <div class="input-field days-field">
      <label>Días de la semana</label>
      <p-multiSelect [options]="weekDayOptions" [(ngModel)]="rule.weekDays" optionLabel="label" optionValue="value"
        defaultLabel="Seleccionar días" appendTo="body" [maxSelectedLabels]="7" [selectedItemsLabel]="'{0} días seleccionados'"
        [disabled]="!allowWrite" [ngModelOptions]="{standalone: true}"></p-multiSelect>
    </div>
    <div class="input-field compact-field">
      <label>Desde</label>
      <p-calendar [timeOnly]="true" appendTo="body" [(ngModel)]="rule.startTime" [disabled]="!allowWrite" [ngModelOptions]="{standalone: true}"></p-calendar>
    </div>
    <div class="input-field compact-field">
      <label>Hasta</label>
      <p-calendar [timeOnly]="true" appendTo="body" [(ngModel)]="rule.endTime" [disabled]="!allowWrite" [ngModelOptions]="{standalone: true}"></p-calendar>
    </div>
    <div class="compact-field action-field" *ngIf="allowWrite">
      <p-button *ngIf="allowWrite" icon="pi pi-trash" styleClass="p-button-text p-button-danger" (click)="removeRule('Normal', index)"></p-button>
    </div>
  </div>

  <div class="mt-3 flex gap-2 justify-content-end" *ngIf="allowWrite">
    <p-button label="Añadir franja" icon="pi pi-plus" styleClass="p-button-text" (click)="addRule('Normal')"></p-button>
    <p-button label="Guardar horario normal" icon="pi pi-check" (click)="saveNormalRules()"></p-button>
  </div>
</p-card>

<p-card class="p-3 mt-3" header="Horario de guardia">
  <div class="text-600">Estas franjas se aplicarán en los días seleccionados y también en los festivos marcados en el calendario.</div>

  <div class="rule-row rule-fields mt-3" *ngFor="let rule of guardRules; let index = index">
    <div class="input-field days-field">
      <label>Días de la semana</label>
      <p-multiSelect [options]="weekDayOptions" [(ngModel)]="rule.weekDays" optionLabel="label" optionValue="value"
        defaultLabel="Seleccionar días" appendTo="body" [maxSelectedLabels]="7" [selectedItemsLabel]="'{0} días seleccionados'"
        [disabled]="!allowWrite" [ngModelOptions]="{standalone: true}"></p-multiSelect>
    </div>
    <div class="input-field compact-field">
      <label>Desde</label>
      <p-calendar [timeOnly]="true" appendTo="body" [(ngModel)]="rule.startTime" [disabled]="!allowWrite" [ngModelOptions]="{standalone: true}"></p-calendar>
    </div>
    <div class="input-field compact-field">
      <label>Hasta</label>
      <p-calendar [timeOnly]="true" appendTo="body" [(ngModel)]="rule.endTime" [disabled]="!allowWrite" [ngModelOptions]="{standalone: true}"></p-calendar>
    </div>
    <div class="compact-field action-field" *ngIf="allowWrite">
      <p-button *ngIf="allowWrite" icon="pi pi-trash" styleClass="p-button-text p-button-danger" (click)="removeRule('Guard', index)"></p-button>
    </div>
  </div>

  <div class="mt-3 flex gap-2 justify-content-end" *ngIf="allowWrite">
    <p-button label="Añadir franja" icon="pi pi-plus" styleClass="p-button-text" (click)="addRule('Guard')"></p-button>
    <p-button label="Guardar horario de guardia" icon="pi pi-check" (click)="saveGuardRules()"></p-button>
  </div>
</p-card>

<p-card class="p-3 mt-3" header="Festivos anuales">
  <div class="mb-3 text-600">Haz clic en un día o arrastra un rango para marcar o desmarcar festivos.</div>
  <app-calendar-year [events]="holidayEvents" (onDayClick)="daySelected($event)" (onDateRangeSelect)="rangeSelected($event)"></app-calendar-year>
</p-card>

<p-dialog header="Festivos" [modal]="true" [(visible)]="visibleHolidayModal" [style]="{ width: '35rem' }">
  <div *ngIf="isSingleSelectedDay(); else rangeTemplate">
    ¿Quiere marcar o quitar como festivo el día {{rangeStartDate | date:'dd/MM/yy'}}?
  </div>
  <ng-template #rangeTemplate>
    ¿Quiere marcar o quitar como festivos desde {{rangeStartDate | date:'dd/MM/yy'}} hasta el {{rangeEndDate | date:'dd/MM/yy'}}?
  </ng-template>

  <div class="mt-4">
    <label for="holiday-description" class="block mb-2">Descripción</label>
    <input id="holiday-description" type="text" pInputText class="w-full" [(ngModel)]="holidayDescription"
      [ngModelOptions]="{standalone: true}" placeholder="Opcional" [disabled]="!allowWrite" />
  </div>

  <div class="mt-4 flex gap-2 justify-content-end">
    <p-button *ngIf="allowWrite" label="Quitar festivos" icon="pi pi-trash" styleClass="p-button-danger" (click)="deleteHolidayRange()"></p-button>
    <div class="flex-grow-1"></div>
    <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="closeHolidayModal()"></p-button>
    <p-button label="Marcar festivos" icon="pi pi-check" *ngIf="allowWrite" (click)="saveHolidayRange()"></p-button>
  </div>
</p-dialog>